import { discount } from './modules/discount'
const SaleLayOut = () => import(/*webpackChunkName:'sale'*/'@/page/sale/saleLayOut.vue')
export const sale={
    path:'/sale',
    component:SaleLayOut,
    redirect:'/main/discount/posList',
    children:[
        discount
    ]
}